/**
 * Create Customer Form Component
 * Simple form for creating new customers.
 * 
 * Extracted from App.js for better code organization.
 */

import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

/**
 * Create Customer Form Component
 */
export const CreateCustomerForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({ name: '', email: '', phone: '', company: '' });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="create-customer-form">
      <div className="space-y-2">
        <Label>Full Name</Label>
        <Input 
          value={formData.name}
          onChange={(e) => setFormData({...formData, name: e.target.value})}
          required
          data-testid="customer-name-input"
        />
      </div>
      <div className="space-y-2">
        <Label>Email</Label>
        <Input 
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({...formData, email: e.target.value})}
          required
          data-testid="customer-email-input"
        />
      </div>
      <div className="space-y-2">
        <Label>Phone</Label>
        <Input 
          value={formData.phone}
          onChange={(e) => setFormData({...formData, phone: e.target.value})}
          required
          data-testid="customer-phone-input"
        />
      </div>
      <div className="space-y-2">
        <Label>Company (Optional)</Label>
        <Input 
          value={formData.company}
          onChange={(e) => setFormData({...formData, company: e.target.value})}
          data-testid="customer-company-input"
        />
      </div>
      <Button type="submit" className="w-full" data-testid="create-customer-submit">
        Create Customer
      </Button>
    </form>
  );
};

export default CreateCustomerForm;
